module.exports = __webpack_public_path__ + "static/media/app-bg.9968f8fe.png";